export const TOPOGRAPHYEVENTS = {
  rgpDrawModeChanged: "rgp-draw-mode-chaned",
  rgpDrawModeInitted: "rgp-draw-mode-initted",
  drawTickColorBar: "draw-tick-color-bark",
  finishDrawTick: "finish-draw-tick",
  mapStyleChanged: "map-style-changed",
  refreshScaleColor: "refresh-scale-color",
  refreshFocus: "refresh-focus",
  colorBarPropChanged: "color-bar-prop-changed",
  diffMapChanged: "diff-map-changed",
  medianModeChanged: "median-mode-changed",
  onDrawStart: "on-draw-start",
  onDrawMove: "on-draw-move",
  onDrawEnd: "on-draw-end",
  diffColorBarChanged: "diff-color-bar-changed",
  showLargeImg: "show-large-image",
  zernikeColorBarChanged: "zernike-color-bar-changed",
  updateZernikeChart: "update-zernike-chart",
  rgpDataChanged: "rgp-data-changed",
  rgpOffsetChanged: "rgp-offset-changed",
  rgpRotate: "rgp-rotate",
  znkDataChanged: "znk-data-changed",
  movableCircleStopped: "movable-circle-stopped",
  fourierDataChanged: "fourier-data-changed"
};



// WEBPACK FOOTER //
// ./src/topography/shared/events.js